(function () {
    'use strict';

    var module = angular.module('ae-datetimepicker', []);

    module.directive('datetimepicker', [
        '$timeout',
        function ($timeout) {
            return {
                restrict: 'EA',
                require: 'ngModel',
                scope: {
                    options: '=?',
                    onChange: '&?',
					onClick: '&?',
					appendToBody: '@?'
                },
                link: function ($scope, $element, $attrs, ngModel) {
                    var dpElement = $element.parent().hasClass('input-group') ? $element.parent() : $element;

                    $scope.$watch('options', function (newValue) {
                        var dtp = dpElement.data('DateTimePicker');
                        $.map(newValue, function (value, key) {
                            dtp[key](value);
                        });
                    }, true);

                    ngModel.$render = function () {
                        // if value is undefined/null do not do anything, unless some date was set before
                        var currentDate = dpElement.data('DateTimePicker').date();
                        if (!ngModel.$viewValue && currentDate) {
                            dpElement.data('DateTimePicker').clear();
                        } else if (ngModel.$viewValue) {
                            // otherwise make sure it is moment object
                            if (!moment.isMoment(ngModel.$viewValue)) {
                                ngModel.$setViewValue(moment(ngModel.$viewValue));
                            }
                            dpElement.data('DateTimePicker').date(ngModel.$viewValue);
                        }
                    };

                    var isDateEqual = function (d1, d2) {
                        return moment.isMoment(d1) && moment.isMoment(d2) && d1.valueOf() === d2.valueOf();
                    };

                    dpElement.on('dp.change', function (e) {
                        if (!isDateEqual(e.date, ngModel.$viewValue)) {
                            var newValue = e.date === false ? null : e.date;
                            ngModel.$setViewValue(newValue);

                            $timeout(function () {
                                if (typeof $scope.onChange === 'function') {
                                    $scope.onChange();
                                }
                            });
                        }
                    });


                    dpElement.on('click', function () {
                        $timeout(function () {
                            if (typeof $scope.onClick === 'function') {
                                $scope.onClick();
                            }
                        });
                    });

					dpElement.datetimepicker($scope.options);
					
					if ($scope.appendToBody) {
						dpElement.on('dp.show', function(e) {
							var datepicker = $('body').find('.bootstrap-datetimepicker-widget:last'),
								position = datepicker.offset(),
								parent = datepicker.parent(),
								parentPos = parent.offset(),
								width = datepicker.width(),
								parentWid = parent.width();
						
							// move datepicker to the exact same place it was but attached to body
							datepicker.appendTo('body');
							datepicker.css({
								position: 'absolute',
								top: position.top,
								bottom: 'auto',
								left: position.left,
								right: 'auto'
							});
						
							// if datepicker is wider than the thing it is attached to then move it so the centers line up
							if (parentPos.left + parentWid < position.left + width) {
								var newLeft = parentPos.left;
								newLeft += parentWid / 2;
								newLeft -= width / 2;
								datepicker.css({left: newLeft});
							}
						})
					}
                }
            };
        }
    ]);
})();